import palette from './palette';

export default {
  overline: {
    color: palette.text.secondary,
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase',
  },
};
